document.addEventListener("turbolinks:load", function () {
  $("#addNote").click(function () {
    $('.note-fields input[type="hidden"]').remove();

    checkboxes = $(".reservation-checkbox");
    for (i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        formString =
          '<input name="reservation_ids[]" type="hidden" value="' +
          checkboxes[i].value +
          '">';
        $(".note-fields").append(formString);
      }
    }
  });

  $("#cancelAll").click(function () {
    $('.cancel-fields input[type="hidden"]').remove();

    checkboxes = $(".reservation-checkbox");
    for (i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        formString =
          '<input name="reservation_ids[]" type="hidden" value="' +
          checkboxes[i].value +
          '">';
        $(".cancel-fields").append(formString);
      }
    }
  });

  $("#toggle-all").click(function () {
    checkboxes = $(".reservation-checkbox");
    for (i = 0; i < checkboxes.length; i++) {
      //checkboxes[i].checked = !checkboxes[i].checked;
      if ($("#toggle-all").is(":checked")) {
        checkboxes[i].checked = true;
      } else {
        checkboxes[i].checked = false;
      }
    }
  });

  $("#hideCompleted").on("click", function () {
    event.preventDefault();
    $(".row--status-cancelled").toggle("slow", function () {});
    $(".row--status-completed").toggle("slow", function () {});
    $(".row--status-no_show").toggle("slow", function () {});
    $("#hideCompleted").addClass("d-none");
    $("#showStatus").removeClass("d-none");
  });

  $("#showStatus").on("click", function () {
    event.preventDefault();
    $(".row--status-cancelled").toggle("slow", function () {});
    $(".row--status-completed").toggle("slow", function () {});
    $(".row--status-no_show").toggle("slow", function () {});
    $("#showStatus").addClass("d-none");
    $("#hideCompleted").removeClass("d-none");
  });

  $("#filterRange").click(function (event) {
    event.preventDefault();
    $("#filterRange").toggleClass("active");
    $("#advancedSearchForm").addClass("d-none");
    $("#filterForm").toggleClass("d-none");
  });

  $("#advancedSearch").click(function (event) {
    event.preventDefault();
    $("#filterForm").addClass("d-none");
    $("#advancedSearch").toggleClass("active");
    $("#advancedSearchForm").toggleClass("d-none");
  });

  $(document).on("change", ".flatpickr-date-selector", function () {
    if ($(".flatpickr-date-selector").val() != "") {
      $("#date-selector").submit();
    }
  });
});
